<template>
  <b-modal
    id="gameModal"
    ok-only
    no-close-on-backdrop
    :visible="true"
    ok-title="Accept"
    size="xl"
    hide-footer
    class="text-center"
    @hide="stopPendingGame"
    @close="stopPendingGame"
  >
    <template #modal-title>
      Basket Ball
    </template>
    <b-spinner
      v-if="isProcessing"
      type="grow"
      class="text-center"
      label="Loading..."
    />
    <iframe
      id="gameFrameContent"
      style="height: 90vh;width: 100%;"
      frameBorder="0"
    />
  </b-modal>

</template>
<script>
import { BModal, BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BSpinner,
  },
  props: {
    isMuted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProcessing: true,
    }
  },
  async created() {
    const scripts = [
      '/basket-ball/jquery-2.1.1.min.js',
      '/basket-ball/ga_init.js',
      '/basket-ball/mindpocket.js',
      '/basket-ball/c2runtime.js',
      '/penguinSkip/starter_ga.js',
    ]
    this.$nextTick(() => {
      setTimeout(() => {
        let html = `<div id="canvasdiv">
          <canvas
            id="gameContainer"
            width="100%"
            height="100vh"
          />
        </div>`
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < scripts.length; i++) {
          html += `<script src="${scripts[i]}"></`
          html += 'script>'
        }
        setTimeout(() => {
          const iframe = document.getElementById('gameFrameContent')
          iframe.contentWindow.document.open()
          iframe.contentWindow.document.write(html)
          iframe.contentWindow.document.close()
          iframe.contentWindow.document.addEventListener('gameOverBasketBall', () => {
            this.$emit('gameOver')
          })
          this.isProcessing = false
        }, 1000)
      }, 500)
    })
  },
  methods: {
    stopPendingGame() {
      this.$emit('gameOver')
    },
  },
}
</script>
<style>
#pacRusher .modal-header .close {
  display:none;
}
</style>
